var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{ref:"myInput",attrs:{"value":_vm.value,"counter":_vm.max,"label":_vm.label,"name":_vm.name,"rules":_vm.formRules,"outlined":"","dense":"","rounded":""},on:{"input":function($event){return _vm.handleInput()}}})}
var staticRenderFns = []

export { render, staticRenderFns }